import { attr, belongsTo } from '@warp-drive/legacy/model';
import { trackedFunction } from 'reactiveweb/function';

import Model from 'umg-ember-backend/models/variant-model';
import {
  buildValidations,
  disabledWhenVariant,
  validator,
} from 'umg-ember-backend/utils/validations';

const Validations = buildValidations({
  title: validator('presence', true),
  slug: [
    validator('presence', true),
    validator('format', {
      regex: /^[a-z0-9]+(?:(?:-|_)+[a-z0-9]+)*$/,
      messageKey: 'forms.taxon.messages.slug',
    }),
  ],
  taxonomy: [
    validator('presence', {
      presence: true,
      disabled: disabledWhenVariant(),
    }),
  ],
});

export const settings = {
  variantProperties: ['title', 'slug', 'description', 'cmsLanguageId'],
};

export default class TaxonomyModel extends Model.extend(Validations) {
  @attr('string') title;
  @attr('string') slug;
  @attr('string') description;

  // Meta fields
  @attr cmsCreated;
  @attr cmsDeleted;
  @attr cmsLocktime;
  @attr cmsModified;
  @attr() cmsHistory;
  @belongsTo('user', { async: true, inverse: null }) cmsOwnerId;
  @belongsTo('user', { async: true, inverse: null }) cmsCreatorId;
  @belongsTo('user', { async: true, inverse: null }) cmsLockerId;
  @belongsTo('user', { async: true, inverse: null }) cmsModifierId;

  // Relations
  @belongsTo('taxonomy', { async: true, inverse: null }) taxonomy;
  @belongsTo('asset', { async: true, inverse: null }) image;

  // Getter and setter
  get displayHeadline() {
    return this.title;
  }

  get displayLabel() {
    const taxonomy = this.resolvedTaxonomy.value;
    const label = [this.title];

    if (taxonomy) {
      label.push(`(${taxonomy?.displayLabel})`);
    }
    return label.join(' ');
  }

  // Functions
  resolvedTaxonomy = trackedFunction(this, async () => {
    return await this.taxonomy;
  });
}
